// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8-0 {\n  display: flex;\n}\n\n._8-1 {\n  flex-direction: row;\n}\n\n._8-2 {\n  flex-direction: column;\n}\n\n._8-3 {\n  flex-direction: row-reverse;\n}\n\n._8-4 {\n  flex-direction: column-reverse;\n}\n\n._8-5 {\n  align-items: center;\n}\n._8-6 {\n  align-items: flex-start;\n}\n._8-7 {\n  align-items: flex-end;\n}\n._8-8 {\n  align-items: stretch;\n}\n._8-9 {\n  align-items: baseline;\n}\n\n._8-a {\n  align-self: center;\n}\n._8-b {\n  align-self: flex-start;\n}\n._8-c {\n  align-self: flex-end;\n}\n._8-d {\n  align-self: stretch;\n}\n._8-e {\n  align-self: baseline;\n}\n\n._8-f {\n  justify-content: center;\n}\n._8-g {\n  justify-content: flex-start;\n}\n._8-h {\n  justify-content: flex-end;\n}\n._8-i {\n  justify-content: space-between;\n}\n._8-j {\n  justify-content: space-around;\n}\n._8-k {\n  justify-content: space-evenly;\n}\n\n._8-l {\n  flex-wrap: wrap;\n}\n\n._8-m {\n  flex-wrap: nowrap;\n}\n\n._8-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_8-0";
export var row = "_8-1";
export var column = "_8-2";
export var rowReverse = "_8-3";
export var columnReverse = "_8-4";
export var alignCenter = "_8-5";
export var alignFlexStart = "_8-6";
export var alignFlexEnd = "_8-7";
export var alignStretch = "_8-8";
export var alignBaseline = "_8-9";
export var alignSelfCenter = "_8-a";
export var alignSelfFlexStart = "_8-b";
export var alignSelfFlexEnd = "_8-c";
export var alignSelfStretch = "_8-d";
export var alignSelfBaseline = "_8-e";
export var justifyCenter = "_8-f";
export var justifyFlexStart = "_8-g";
export var justifyFlexEnd = "_8-h";
export var justifySpaceBetween = "_8-i";
export var justifySpaceAround = "_8-j";
export var justifySpaceEvenly = "_8-k";
export var wrapWrap = "_8-l";
export var wrapNowrap = "_8-m";
export var wrapWrapReverse = "_8-n";
export default ___CSS_LOADER_EXPORT___;
